export default __webpack_public_path__ + "43fdcaeec8ed94307b7a8ad8108040d4.png";